// extracted by mini-css-extract-plugin
export default {"root":"Header__root--gHWkt","responsive":"Header__responsive--2hvIc","narrow":"Header__narrow--3o5ZC","controlsWrapper":"Header__controlsWrapper--3jDI3"};